import React from "react";

interface AuthorDetailsProps {
    AuthorPictureUrl?: string;
    AuthorName: string;
    AuthorDescription?: string;
}

/**
 * Author details component that displays author information
 */
const AuthorDetails: React.FC<AuthorDetailsProps> = ({ AuthorPictureUrl, AuthorName, AuthorDescription }) => {
    return (
        <div className="author-details-container">
            <div className="author-details">
                {AuthorPictureUrl && (
                    <div className="author-details__image-container">
                        <img src={AuthorPictureUrl} loading="lazy" alt={`Billede af ${AuthorName}`} />
                    </div>
                )}
                <div className="author-details__meta">
                    <h1
                        className="author-details__meta__name"
                        dangerouslySetInnerHTML={{ __html: AuthorName }}
                    />
                    {AuthorDescription && (
                        <div
                            className="author-details__meta__description"
                            dangerouslySetInnerHTML={{ __html: AuthorDescription }}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default AuthorDetails;
